import { render, staticRenderFns } from "./LoadingModalComponent.vue?vue&type=template&id=3c2efd4c&scoped=true"
import script from "./LoadingModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingModalComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LoadingModalComponent.vue?vue&type=style&index=0&id=3c2efd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2efd4c",
  null
  
)

export default component.exports